/* eslint-disable import/no-extraneous-dependencies, arrow-body-style,object-curly-newline */
import DocHoc from 'platform/react/hoc/pubsub/doc'
import Section from 'ui/Element/Acl/Section'

const AclSubbedSection = DocHoc(Section)

export default AclSubbedSection
